/** @jsx jsx */
import { useContext, useState, useEffect, useMemo } from "react";
import Fuse from "fuse.js";
import { Box, Text, jsx } from "theme-ui";
import { IoIosSearch, IoIosClose } from "react-icons/io";
import ProductGrid from "../ui-elements/product-grid/product-grid";
import styles from "./search.style";

type PropsType = {
  allShopifyProduct: any;
};

const fuseOptions = {
  isCaseSensitive: false,
  findAllMatches: false,
  includeMatches: false,
  includeScore: false,
  useExtendedSearch: false,
  minMatchCharLength: 2,
  shouldSort: true,
  threshold: 0.4, // lower threshold value means more accurate results
  location: 0,
  distance: 100,
  keys: ["node.title", "node.tags"],
};

const Search: React.FC<PropsType> = (props) => {
  const { allShopifyProduct } = props;
  const products = allShopifyProduct?.edges || [];
  const [value, setValue] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [noResult, setNoResult] = useState(false);
  const fuse = new Fuse(products, fuseOptions);

  useEffect(() => {
    const handler = setTimeout(() => {
      let searchData: any = [];
      if (value.length) {
        const fuseData = fuse.search(value);
        if (fuseData && fuseData.length) {
          fuseData.forEach((data) => {
            searchData.push(data.item);
          });
        }
      }
      setSearchData(searchData);
    }, 500);
    return () => clearTimeout(handler);
  }, [value]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (value.length && !searchData.length) {
        setNoResult(true);
      } else {
        setNoResult(false);
      }
    }, 1000);
    return () => {
      clearTimeout(handler);
    };
  }, [value, searchData]);

  const handleClear = () => {
    console.log("on clear funck");
    setValue("");
  };

  return (
    <Box sx={styles.wrapper}>
      <Box
        as="form"
        sx={styles.fieldWrapper}
        onSubmit={(e) => e.preventDefault()}
        className="search"
      >
        <IoIosSearch className="search-icon" />
        <input
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="What Are You Looking For?"
          autoComplete="off"
        />
        {value && (
          <IoIosClose className="close-icon" onClick={() => setValue("")} />
        )}
      </Box>

      {value && searchData.length ? (
        <Box sx={styles.searchResult}>
          <ProductGrid
            gridTitle="Search Result"
            products={searchData}
            close={handleClear}
          />
        </Box>
      ) : null}
      {noResult && (
        <Box className="notFound" sx={styles.searchResult}>
          <Text as="h2">No Result Found</Text>
        </Box>
      )}
    </Box>
  );
};

export default Search;
